import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LogicGameClient } from "../app/LogicGameClient";
import { PwaRegistrar } from "../app/PwaRegistrar";
import "../app/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PwaRegistrar />
    <LogicGameClient />
  </StrictMode>,
);
